$(function() {
	$("#resultDialog").dialog({
		resizable : false,
		height : 240,
		width : 400,
		modal : true,
		buttons : [ {
			text : FmtMessage.getMessage('js.search.no.result'),
			click : function() {
				$(this).dialog("close");
				if($("#redirectPage").length){
					window.location = $("#redirectPage").val();
				}
			}
		} ]
	});
	
	$('.ui-dialog-titlebar-close').click(function () {

		$('#resultDialog').dialog("close");
		if($("#redirectPage").length){
			window.location = $("#redirectPage").val();
		}
	});

});